export default __webpack_public_path__ + "static/media/star.70cfb006.svg";